import React, { useState, useEffect, useRef } from "react";
import { Field, useField } from "formik";

import { Input, SelectButton, Container, Options, SearchInput } from "./styles";
import TplGroup from "../tpl-group";
import IField from "../../../../interfaces/field";
import Icon from "../../../icon";

type IProps = any & IField;

const SelectChecklist: React.FC<IProps> = ({
  required = false,
  name,
  prefixName,
  title,
  options,
  onChange,
  ...el
}: IProps) => {
  const [checklistIsOpen, setChecklistIsOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [optionsList, setOptionsList] = useState(options);
  const [field] = useField(name);
  const containerRef = useRef<HTMLDivElement | null>(null);

  const handleOptionChange = (optionValue: any): void => {
    const currentValues = field.value || [];
    const updatedValues = currentValues.includes(optionValue)
      ? currentValues.filter((value: any) => value !== optionValue)
      : [...currentValues, optionValue];

    field.onChange({
      target: {
        name,
        value: updatedValues,
      },
    });

    if (onChange) {
      onChange(updatedValues);
    }
  };

  const handleClickOutside = (event: any): void => {
    if (
      containerRef.current &&
      !containerRef.current.contains(event.target) &&
      event.target.name !== "searchInput"
    ) {
      setChecklistIsOpen(false);
    }
  };

  const handleSelectButtonClick = (
    e: React.MouseEvent<HTMLDivElement>
  ): void => {
    const target = e.target as HTMLInputElement;
    if (target.name !== "searchInput") {
      setChecklistIsOpen((state: boolean) => !state);
    }
  };

  const handleSearchInputChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ): void => {
    setSearchValue(e.target.value);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (searchValue) {
      const filteredOptions = options.filter((option: any) =>
        option?.label
          ? option.label.toLowerCase().includes(searchValue.toLowerCase())
          : option.toLowerCase().includes(searchValue.toLowerCase()));
      setOptionsList(filteredOptions);
    } else {
      setOptionsList(options);
    }
  }, [searchValue, options]);

  return (
    <TplGroup
      name={`${prefixName}${name}`}
      prefixName={prefixName}
      title={title}
      required={required}
      {...el}
    >
      <Container ref={containerRef}>
        <SelectButton onClick={handleSelectButtonClick}>
          {checklistIsOpen ? (
            <SearchInput
              name="searchInput"
              value={searchValue}
              onChange={handleSearchInputChange}
              placeholder="Buscar..."
            />
          ) : (
            el.placeholder
          )}
          <Icon name="arrow-down" />
        </SelectButton>
        <Options
          style={{
            ...el.containerStyle,
            display: checklistIsOpen ? "flex" : "none",
          }}
        >
          {optionsList.map((option: any) => (
            <div key={JSON.stringify(option)} style={{ ...el.style }}>
              <Field
                type="checkbox"
                name={name}
                value={option?.value || option}
                as={Input}
                onChange={() => handleOptionChange(option?.value || option)}
              />
              <span>{option?.label || option}</span>
            </div>
          ))}
        </Options>
      </Container>
    </TplGroup>
  );
};

export default SelectChecklist;
